import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LangSrcService} from '../../../services/lang-src/lang-src.service';
import {ExamService} from '../../../services/exam/exam.service';
import {GameLevelService} from '../../../services/games/game-level/game-level.service';
import {AudioService} from '../../../services/audio/audio.service';
import {CommonModule} from '@angular/common';
import {ProgressCircleComponent} from '../../../components/progress/progress-circle/progress-circle.component';
import {ProgressBarSimpleComponent} from '../../../components/progress/progress-bar-simple/progress-bar-simple.component';
import {GameImagePipe} from '../../../pipes/game-image.pipe';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-exam-result',
  standalone: true,
  imports: [
    CommonModule,
    ProgressCircleComponent,
    ProgressBarSimpleComponent,
    GameImagePipe,
    TranslateModule
  ],
  templateUrl: './exam-result.component.html',
  styleUrls: ['./exam-result.component.scss']
})
export class ExamResultComponent implements OnInit {

  examResult: any;
  level: any;
  answerType: string = 'first_listening';

  constructor(
    private examSrv: ExamService,
    public langSrcSrv: LangSrcService,
    public route: ActivatedRoute,
    private levelSrv: GameLevelService,
    private router: Router,
    public audioSrv: AudioService
  ) { }

  trackByIndex(index: number) { return index; }

  async ngOnInit(): Promise<void> {
    this.level = await this.levelSrv.findById(this.route.snapshot.params.idLevel);
    this.examResult = await this.examSrv.result(this.route.snapshot.params.idLevel);
  }

  async navigateToLevels(): Promise<void> {
    await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'games']);
  }

  displayScore(first: string, second: string): string {
    return first + ' / ' + second;
  }

  calculPercent(count: number, total: number): number {
    return Math.round((count / total) * 100);
  }

  displayPercent(percent: number): string {
    return percent + '%';
  }

  getTimer(): string {
    const dateStart = new Date(this.examResult.examResult.dateStart);
    const dateEnd = new Date(this.examResult.examResult.dateEnd);

    const diffInMs = Math.abs(dateStart.getTime() - dateEnd.getTime());

    const seconds = Math.floor((diffInMs / 1000) % 60);
    const minutes = Math.floor((diffInMs / (1000 * 60)) % 60);
    const hours = Math.floor((diffInMs / (1000 * 60 * 60)) % 24);

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  getAnswers(): Array<any> {
    const [order, type] = this.answerType.split("_");
    return this.examResult.answers[type][order] ?? this.examResult.answers.listening.first;
  }

  onChangeType(type: string): void {
    this.answerType = type;
  }
}
